var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "main-space-and-equipment"
  }, [_c('v-container', [_c('ul', {
    staticClass: "main-space-and-equipment__items"
  }, [_c('li', [_c('tit-primary', {
    staticClass: "main-space-and-equipment__title"
  }, [_vm._v("공간과 장비")]), _c('v-row', {
    staticClass: "row--sm"
  }, _vm._l(_vm.items, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "6"
      }
    }, [_c('v-card', {
      staticClass: "space-card",
      attrs: {
        "to": item.path,
        "flat": "",
        "tile": ""
      }
    }, [_c('v-img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }), _c('v-card-title', [_c('u-tit-default', {
      staticClass: "tit--sm"
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1), _c('v-card-text', [_c('txt-primary', {
      staticClass: "txt--lg"
    }, [_vm._v("바로가기")])], 1)], 1)], 1);
  }), 1)], 1), _c('li', [_c('v-row', {
    staticClass: "h-100",
    attrs: {
      "align": "center",
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('txt-primary', {
    staticClass: "txt--xl line-height-15 txt--dark"
  }, [_vm._v(" 봉제공장과 의류업체 간의 "), _c('br'), _vm._v(" 매칭 지원 플랫폼 ")]), _c('router-link', {
    staticClass: "donggori-link",
    attrs: {
      "to": "/donggori/signup"
    }
  }, [_c('u-tit-default', {
    staticClass: "tit--lg"
  }, [_vm._v("동고리 가입 안내"), _c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    staticClass: "icon-donggori",
    attrs: {
      "src": "/images/icon/icon-donggori.svg",
      "alt": ""
    }
  })], 1)], 1), _c('a', {
    attrs: {
      "href": ""
    }
  })], 1)])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }